// extracted by mini-css-extract-plugin
export default {"lineSeparator":"lineSeparator_lineSeparator__emd+J"};